export default __webpack_public_path__ + "static/Informacion_de_Pagos-4f22f7de3c89d276e78e6adaf552f185.png";